import { useState, useEffect } from 'react'
import { supabaseHelpers } from '../lib/supabase'

export const useUsers = () => {
  const [users, setUsers] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const fetchUsers = async () => {
    setLoading(true)
    setError(null)
    console.log('Fetching users...');
    
    try {
      const { data, error } = await supabaseHelpers.getAllUsers()
      
      console.log('Users fetch result:', { 
        count: data?.length || 0, 
        users: data?.map(u => ({ id: u.id, email: u.email, role: u.role })),
        error 
      });
      
      if (error) {
        console.error('Error fetching users:', error);
        setError(error.message)
      } else {
        console.log('Setting users:', data);
        setUsers(data || [])
      }
    } catch (err) {
      console.error('Exception in fetchUsers:', err);
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchUsers()
  }, [])

  const deleteUser = async (userId) => {
    console.log('Deleting user:', userId);
    
    try {
      const { error } = await supabaseHelpers.deleteUser(userId)
      if (error) throw error

      console.log('User deleted, refreshing list...');
      await fetchUsers() // Refresh the list
      return { error: null }
    } catch (err) {
      console.error('Error deleting user:', err);
      return { error: err }
    }
  }

  return {
    users,
    loading,
    error,
    deleteUser,
    refetch: fetchUsers
  }
}